document.addEventListener('DOMContentLoaded', function() {
    const details = document.querySelectorAll('.faq_details_tittle');

    details.forEach(detail => {
        const summary = detail.querySelector('.faq-summary');
        const content = detail.querySelector('.answer_accordion__content-wrapper');

        summary.addEventListener('click', function(e) {
            e.preventDefault();

            if (detail.hasAttribute('open')) {
                const contentHeight = content.scrollHeight;
                content.style.height = contentHeight + 'px';

                requestAnimationFrame(() => {
                    content.style.height = '0px';
                });

                setTimeout(() => {
                    detail.removeAttribute('open');
                }, 300);
            } else {
                detail.setAttribute('open', '');
                const contentHeight = content.scrollHeight;
                content.style.height = '0px';

                requestAnimationFrame(() => {
                    content.style.height = contentHeight + 'px';
                });

                setTimeout(() => {
                    content.style.height = 'auto';
                }, 300);
            }
        });
    });
});
